import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CenterDto, CenterService } from '@malirang/api-client';
import {
  AlertService,
  Button,
  Icon,
  ToastService,
} from '@malirang/front-share';
import { CenterProfileComponent } from 'apps/client/src/components/center/profile/center-profile.component';

@Component({
  selector: 'app-select-center-content',
  templateUrl: './select-center-content.component.html',
  styleUrls: ['./select-center-content.component.scss'],
  imports: [CommonModule, Button, CenterProfileComponent, RouterLink, Icon],
})
export class SelectCenterContentComponent {
  readonly router = inject(Router);
  readonly alertService = inject(AlertService);
  readonly centerService = inject(CenterService);
  readonly toastService = inject(ToastService);

  centers = input.required<CenterDto[]>();
  currentCenter = input<CenterDto | null>(null);
  select = output<CenterDto>();

  navigate = output<void>();

  handleNavigate(url: string) {
    this.navigate.emit();
    this.router.navigate([url]);
  }

  createPrivateCenter() {
    this.alertService
      .open({
        title: '개인으로 활동',
        content: '개인으로 활동하시겠습니까?',
        type: 'info',
      })
      .closed.subscribe({
        next: (res) => {
          if (res?.action === 'confirm') {
            this.centerService
              .userCenterControllerCreatePrivateCenter()
              .subscribe({
                next: (res) => {
                  this.toastService.success('센터가 생성되었습니다.');
                  window.location.reload();
                },
                error: () => {
                  this.toastService.error('센터 생성에 실패했습니다.');
                },
              });
          }
        },
      });
  }
}
